import { LOGO_MARK_PATHS, LOGO_VIEWBOX } from './logoMark'

const SOURCES = {
  // White lettering, for a dark surface (the recovery screen).
  light: '/images/logo-horizontal-light.svg',
  // Ink lettering, for a light surface (the brand canvas).
  dark: '/images/logo-horizontal.svg',
}

/**
 * The Loving Loyalty logo with a light that runs around its mark: a short
 * segment travels each outline, then rests, like a pulse through the brand.
 * The logo itself is the real file; the light is an overlay on the same
 * viewBox (both files share the mark). Still under reduced motion.
 */
export default function TracedLogo({
  className = '',
  pace = 'rest',
  tone = 'light',
}: {
  className?: string
  /** `rest`: a lap now and then. `loop`: lap after lap, for a waiting screen. */
  pace?: 'rest' | 'loop'
  tone?: 'light' | 'dark'
}) {
  return (
    <span className={`relative inline-block ${className}`}>
      <img src={SOURCES[tone]} alt="Loving Loyalty" className="block h-full w-auto" />
      <svg viewBox={LOGO_VIEWBOX} aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full overflow-visible">
        {LOGO_MARK_PATHS.map((d, i) => (
          <path
            key={i}
            d={d}
            pathLength={100}
            fill="none"
            strokeWidth={5}
            strokeLinecap="round"
            className={`opacity-0 [stroke-dasharray:14_86] ${
              tone === 'light'
                ? 'stroke-brass-100 [filter:drop-shadow(0_0_6px_rgba(232,194,122,0.9))]'
                : 'stroke-brass-300 [filter:drop-shadow(0_0_4px_rgba(213,153,38,0.7))]'
            } ${pace === 'loop' ? 'motion-safe:animate-trace-loop' : 'motion-safe:animate-trace'}`}
          />
        ))}
      </svg>
    </span>
  )
}
